module.exports = __webpack_public_path__ + "28dd2591d76ce7a894371347caa7ecb6.jpg";